import { Controller } from '@hotwired/stimulus'

const NO_VISIT = 'no_visit'

// Keeps the audience card on the criterion being chosen, not the one the page
// loaded with.
export default class extends Controller {
  static targets = [
    'audience', 'visitDays', 'visitDaysInput', 'lookbackInput', 'deliveryLine', 'ageLine', 'audienceLine',
    'frequency', 'sampleLimitInput', 'sampleLimitHint', 'preventDuplicates', 'limitedRepetition'
  ]
  // Read from the form rather than repeated here: the minimum age is the
  // preset's rule, and the suggested volume is a share of the segment's own
  // leads — a copy of either in JS would drift the day it changes.
  static values = { minAge: Number, suggestions: Object }

  connect() {
    this.frequency = this.frequencyTarget.value
    this.toggle()
    this.toggleLimitedRepetition()
  }

  // A limit sized for one day is a régua that never reaches anyone when it fires
  // once a month, so the cadence carries its suggestion along — unless the
  // operator has typed a number of their own, which is theirs to keep.
  retune() {
    const previous = this.suggestionsValue[this.frequency]
    const next = this.suggestionsValue[this.frequencyTarget.value]

    this.frequency = this.frequencyTarget.value
    if (!next) return

    if (previous && this.sampleLimitInputTarget.value === String(previous.limit)) {
      this.sampleLimitInputTarget.value = next.limit
    }
    this.sampleLimitHintTarget.textContent = next.hint
  }

  toggle() {
    const noVisit = this.audienceTarget.value === NO_VISIT

    this.visitDaysTarget.classList.toggle('hidden', !noVisit)
    this.deliveryLineTarget.textContent = this.deliveryLine(noVisit)
    this.ageLineTarget.textContent = this.ageLine()
    this.audienceLineTarget.textContent = this.criterionLine(noVisit)
  }

  toggleLimitedRepetition() {
    this.limitedRepetitionTarget.classList.toggle('hidden', !this.preventDuplicatesTarget.checked)
  }

  deliveryLine(noVisit) {
    return noVisit ? 'que receberam mensagem da IA' : 'que receberam mensagem da IA e não responderam'
  }

  ageLine() {
    return `com ${this.minAgeValue} a ${this.lookbackInputTarget.value} dias de conversa`
  }

  criterionLine(noVisit) {
    if (noVisit) {
      return `e sem visita marcada — ou com visita que já passou há ${this.visitDaysInputTarget.value} dias ou mais`
    }
    if (this.audienceTarget.value) return 'e cujo lead nunca chegou ao destino selecionado'

    return 'e que não avançaram pelo critério escolhido abaixo'
  }
}
